import { createTheme } from "@mui/material";
import { nbNO } from '@mui/material/locale';

const Sb1Theme = createTheme({
    palette: {
        primary: {
            main: "#002776"
        },
        secondary: {
            main: "#247a5d"
        }
    },
    logo: "https://fakturasalg.sb1finans.no/wp-content/uploads/rgb_SB1_Finans_SMN_verti_pos.png",
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 28,
                }
            }
        },
        MuiStepLabel: {
            styleOverrides: {
                root: {
                    "& .Mui-active": {
                        color: "#99ffff"
                    }
                }
            }
        },
        MuiStep: {
            styleOverrides: {
                root: {
                    ":active": {
                        backgroundColor: "#fff"
                    }
                }
            }
        }
    }
}, nbNO)

export default Sb1Theme;
